import { EvtHeader } from "components/header";
import React from "react";
import TagForm from "../form";

const CreateTag = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Tag" />
      <div className="p-6 max-w-2xl">
        <TagForm />
      </div>
    </div>
  );
};

export default CreateTag;
